import styled from "@emotion/styled";
import { Container } from "@mui/material";
import { defaultContainerStyles } from "../../styles/css.styles";
export const StyledAddonsSectionContainer = styled(Container)(({ theme }) => ({
  ...defaultContainerStyles(theme),
}));
